import {
  Component,
  NgModule,
  Input,
  Output,
  EventEmitter,
  OnInit,
  effect,
} from "@angular/core";
import { CommonModule } from "@angular/common";

import { AuthService, IUser } from "../../services";
import { UserPanelModule } from "../user-panel/user-panel.component";
import { DxToolbarModule } from "devextreme-angular/ui/toolbar";

import { Router } from "@angular/router";
import { ThemeSwitcherModule } from "../theme-switcher/theme-switcher.component";
import {
  DxBoxModule,
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDateRangeBoxModule,
  DxFormModule,
  DxResponsiveBoxModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxValidatorModule,
} from "devextreme-angular";
import { FormsModule } from "@angular/forms";
import { UIUtils } from "../../../services/uiutils.service";
import { ChapterStateManagement } from "../../../services/chapterstatemanagement";
import { SubChapterStateManagement } from "../../../services/subchapterstatemanagement";
import { AppStateManageService } from "../../../services/app-state-manage.service";
import { environment } from "../../../../environments/environment";
import { Roles } from "../../../classes/infrastructure/enums";
import { SidebarMenuStateService } from "../../../services/sidebarmenustateservice";
import { NotificationManagementService } from "../../../services/notificationmanagement.service";
import { NotificationRecords } from "../../../classes/domain/entities/website/notificationrecord/notificationrecord";
import { filter, Subject, take, takeUntil } from "rxjs";
import notify from "devextreme/ui/notify";
import { ServerCommunicatorService } from "../../../services/server-communicator.service";
import { Profile } from "../../../classes/domain/entities/website/masters/login-user-profile/profile";
import { BaseUrlService } from "../../../services/baseurl.service";
import {
  BreadcrumbItem,
  BreadcrumbService,
} from "../../../services/breadcrumb.service";
import { ProfileStateService } from "../../../services/profilestate.service";
import { LanguageService } from "../../../services/language.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-header",
  templateUrl: "header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  currentDay: Date = new Date();
  currentDate: Date = new Date();
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IUser | null = { email: "" };

  isRefreshing = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private uiUtils: UIUtils,
    private baseUrl: BaseUrlService,
    private appStateManage: AppStateManageService,
    private chapterstatemanagement: ChapterStateManagement,
    private subchapterstatemanagement: SubChapterStateManagement,
    private notificationService: NotificationManagementService,
    private sidebarMenuState: SidebarMenuStateService,
    private serverCommunicatorService: ServerCommunicatorService,
    private breadcrumbService: BreadcrumbService,
    private profileState: ProfileStateService,
    public langService: LanguageService,
    private translate: TranslateService,
  ) {}

  // userMenuItems = [
  //   //   {
  //   //   text: 'Profile',
  //   //   icon: 'user',
  //   //   onClick: () => {
  //   //     this.router.navigate(['/profile']);
  //   //   }
  //   // },
  //   {
  //     text: "Profile",
  //     isProfile: true,
  //     onClick: () => {
  //       this.router.navigate(["/Profile"]);
  //     },
  //   },
  //   {
  //     text: "Password Change",
  //     icon: "unlock",
  //     onClick: () => {
  //       this.router.navigate(["/Change_Password"]);
  //     },
  //   },
  //   {
  //     text: "Logout",
  //     icon: "runner",
  //     onClick: async () => {
  //       let response = await this.authService.logOut();
  //       if (!response?.Successful) alert(response?.message);
  //       // this.router.navigate(['/login-form']);
  //     },
  //   },
  //   {
  //     text: `Version: ${environment.version}`,
  //     icon: "globe",
  //     disabled: true,
  //     cssClass: "menu-version-item",
  //   },
  //   // ── Language header row (non-clickable label) ──
  //   {
  //     text: "Language",
  //     isLanguageMenu: true,   // ← triggers custom template
  //   },
  // ];
  userMenuItems: any[] = [];
  loadUserMenu() {
    this.userMenuItems = [
      {
        text: this.langService.currentLang === "mr" ? "प्रोफाइल" : "Profile",
        isProfile: true,
        onClick: () => this.router.navigate(["/Profile"]),
      },
      {
        text:
          this.langService.currentLang === "mr"
            ? "पासवर्ड बदला"
            : "Password Change",
        icon: "unlock",
        onClick: () => this.router.navigate(["/Change_Password"]),
      },
      {
        text: this.langService.currentLang === "mr" ? "लॉगआउट" : "Logout",
        icon: "runner",
        onClick: async () => {
          let response = await this.authService.logOut();
          if (!response?.Successful) alert(response?.message);
        },
      },
      {
        text: `${this.langService.currentLang === "mr" ? "आवृत्ती" : "Version"}: ${environment.version}`,
        icon: "globe",
        disabled: true,
        cssClass: "menu-version-item",
      },
      {
        text: this.langService.currentLang === "mr" ? "भाषा" : "Language",
        isLanguageMenu: true,
      },
    ];
  }
  ChapterRef: number = 0;
  SubChapterRef: number = 0;
  LoginRef: number = 0;
  isSubChapterDropdownDisabled: boolean = false;
  isChapterDropdownDisabled: boolean = false;
  UserRole: number = 0;
  ChapterName: string = "";
  RoleName: string = "";
  UserDisplayName: string = "";
  LastSelectedSubChapterRef: number = 0;
  LastSelectedChapterRef: number = 0;
  handlerId: number = 0;
  IsShowBtn: boolean = true;
  isSubChapterDropdownVisible: boolean = true; // Controls dropdown visibility for SubChapter\
  isChapterDropdownVisible = true; // Controls dropdown visibility for Chapter\
  isMobile = false;
  notificationCount: number = 0;
  LoginUserProfileData: Profile[] = [];
  profileImageUrl: string | null = null;
  LoginToken: string = "";
  LoginRole: number = 0;
  Roles = Roles;
  breadcrumbs: BreadcrumbItem[] = [];

  private destroy$ = new Subject<void>();
  currentLang: "en" | "mr" = "en";

  PHCName: string = "";
  SCName: string = "";
  VillageName: string = "";

  async ngOnInit() {
    this.LoginToken = this.appStateManage.getLoginToken();
    this.LoginRole = this.appStateManage.getRole();

    this.loadUserMenu();
    // let token = this.sidebarMenuState.getToken();
    // console.log('token :', token);
    // console.log('logintoken', logintoken);
    if (this.LoginToken) {
      // debugger
      await this.getValidateMenuStateData();
      await this.RoleWiseAuthority();
    }

    // add this
    this.breadcrumbService.breadcrumbs.subscribe((items) => {
      this.breadcrumbs = items;
    });

    // console.log(' this.notificationCount :', this.notificationCount);

    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize.bind(this));
    this.LoginRef = this.appStateManage.getLoginUserRef();
    if (this.LoginRef) {
      // this.FormulateUserRecord(this.LoginRef);
    }
    this.UserDisplayName = this.appStateManage.getUserDisplayName();
    const profileimg = this.appStateManage.getProfileImage();
    if (profileimg) {
      if (profileimg.startsWith("blob:") || profileimg.startsWith("http")) {
        // ✅ Already a full URL
        this.profileImageUrl = profileimg;
      } else {
        // ✅ Just a filename — build server URL
        const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();
        this.profileImageUrl = `${imageBaseUrl}${profileimg}/${this.LoginToken}?t=${Date.now()}`;
      }
    }
    // console.log("UserDisplayName :", this.UserDisplayName);
    let RoleName = this.appStateManage.getRoleName();
    this.RoleName = RoleName || "Unknown Role";

    // For updating location names based on language selection
    this.updateLocationNames();

    // Re-update when language changes
    this.langService.lang$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateLocationNames();
    });

    this.authService.getUser().then((e) => (this.user = e.data));
    this.updateDropdownVisibilityByRole();
    const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();

    // For Updating Profile image and User Name
    this.profileState.profileImage
      .pipe(takeUntil(this.destroy$))
      .subscribe((url) => {
        if (url) {
          // ✅ If already a full URL (blob or http), use directly
          if (url.startsWith("blob:") || url.startsWith("http")) {
            this.profileImageUrl = url;
          } else {
            // ✅ Only build server URL if it's just a filename
            const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();
            this.profileImageUrl = `${imageBaseUrl}${url}/${this.LoginToken}?t=${Date.now()}`;
          }
        }
      });

    this.profileState.displayName
      .pipe(takeUntil(this.destroy$))
      .subscribe((name) => {
        if (name) this.UserDisplayName = name;
      });

    // this.FormulateUserRecord(this.LoginRef);

    this.langService.lang$.pipe(takeUntil(this.destroy$)).subscribe((lang) => {
      this.currentLang = lang;
      this.loadUserMenu();
      this.updateLocationNames();
    });
  }

  updateLocationNames() {
    const isMr = this.langService.currentLang === "mr";
    this.PHCName = isMr
      ? this.appStateManage.getPHCNameMR()
      : this.appStateManage.getPHCNameEN();
    this.SCName = isMr
      ? this.appStateManage.getSCNameMR()
      : this.appStateManage.getSCNameEN();
    this.VillageName = isMr
      ? this.appStateManage.getVillageNameMr()
      : this.appStateManage.getVillageNameEn();

    this.UserDisplayName = isMr
      ? this.appStateManage.getUserDisplayNameMR()
      : this.appStateManage.getUserDisplayNameEN();
    this.RoleName = isMr
      ? this.appStateManage.getRoleNameMR()
      : this.appStateManage.getRoleNameEN();
  }

  // getValidateMenuStateData = async () => {
  //   const menuRes = await this.serverCommunicatorService.GetValidMenuItemList();
  //   // 🔥 Push data into state
  //   this.sidebarMenuState.setLoginUserData(menuRes.ObjectTag);
  // };

  getValidateMenuStateData = async () => {
    const menuRes = await this.serverCommunicatorService.GetValidMenuItemList();
    this.sidebarMenuState.setMenuOnly(menuRes.ObjectTag); // ← NEW
  };

  FormulateUserRecord = async (LoginUserRef: number) => {
    let lst = await Profile.FetchEntireListByLoginRef(
      LoginUserRef,
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    this.LoginUserProfileData = lst;

    const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();

    if (this.LoginUserProfileData[0].p.profile_pic_path) {
      this.profileImageUrl = `${imageBaseUrl}${this.LoginUserProfileData[0].p.profile_pic_path}/${this.LoginToken}`;
    }
  };

  RoleWiseAuthority = async () => {
    let role = this.sidebarMenuState.getRole();
    // console.log('Role', ref);
    // if (role == Roles.AF || role == Roles.BCM || role == Roles.DCM) {
    if (role == Roles.AF || role == Roles.BCM || role == Roles.Asha) {
      this.IsShowBtn = true;

      let loginuserref = this.sidebarMenuState.getUserRef();
      // debugger
      if (loginuserref) {
        this.notificationService.SubscribeToNotifications(loginuserref);

        this.notificationService
          .getNotificationCount$(loginuserref)
          .subscribe((count) => {
            // console.log("🔔 COUNT RECEIVED IN COMPONENT:", count);
            this.notificationCount = count;
          });
      }
    } else {
      this.IsShowBtn = false;
    }
  };

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768; // adjust as needed
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };
  // on header label according to user role //
  get userRoleLabel(): string {
    switch (this.UserRole) {
      case 100:
        return "Super Admin";
      case 200:
        return "Chapter Admin";
      case 300:
        return "Sub-Chapter Admin";
      default:
        return "User";
    }
  }

  gotoNotification = async () => {
    await this.router.navigate(["Notification"]);
  };

  // RefreshDomainCache = async () => {
  //   try {
  //     const resp = await this.serverCommunicatorService.RefreshDomainCache();
  //     console.log('resp DomainCache :', resp);

  //     if (resp && resp.Successful) {
  //        notify('Cache refreshed successfully', 'success', 3000);
  //     } else {
  //        this.uiUtils.showErrorMessage('Error', resp?.Message);
  //     }
  //   } catch (error) {
  //     notify("Something went wrong", 'error', 3000);
  //   }
  // };

  RefreshDomainCache = async () => {
    if (this.isRefreshing) return;

    await this.uiUtils.showConfirmationMessagelang(
      this.translate.currentLang === "mr" ? "पुष्टी करा" : "Confirm",
      this.translate.currentLang === "mr"
        ? `आपण कॅशे क्लिअर करू इच्छिता का?<br/>होय केल्यास कॅशे रीफ्रेश होईल`
        : `Do you want to clear cache?<br/>If yes, cache will be refreshed`,

      async () => {
        this.isRefreshing = true; //disable button immediately to prevent multiple clicks

        try {
          const resp =
            await this.serverCommunicatorService.RefreshDomainCache();
          console.log("resp DomainCache :", resp);

          if (resp && resp.Successful) {
            notify(
              this.translate.currentLang === "mr"
                ? "कॅशे यशस्वीरित्या रीफ्रेश झाले"
                : "Cache refreshed successfully",
              "success",
              3000,
            );
          } else {
            this.uiUtils.showErrorMessage(
              this.translate.currentLang === "mr" ? "त्रुटी" : "Error",
              resp?.Message,
            );
          }
        } catch (error) {
          notify(
            this.translate.currentLang === "mr"
              ? "काहीतरी चूक झाली"
              : "Something went wrong",
            "error",
            3000,
          );
        } finally {
          this.isRefreshing = false; //  VERY IMPORTANT
        }
      },
    );
  };

  // Accordinfg to user role dropdown hide /show //
  updateDropdownVisibilityByRole() {
    if (this.UserRole === 100 || this.UserRole === 300) {
      this.isChapterDropdownVisible = true;
      this.isSubChapterDropdownVisible = true;
    } else if (this.UserRole === 200) {
      this.isChapterDropdownVisible = true;
      this.isSubChapterDropdownVisible = false;
    }
    //  else if (this.UserRole === 300) {
    //   this.isChapterDropdownVisible = true;
    //   this.isSubChapterDropdownVisible = true;
    // }
    else {
      // Fallback (hide both)
      this.isChapterDropdownVisible = false;
      this.isSubChapterDropdownVisible = false;
    }
  }

  navigateBreadcrumb(path: string) {
    this.router.navigate([path]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule,
    ThemeSwitcherModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxDateRangeBoxModule,
    DxTextBoxModule,
    DxResponsiveBoxModule,
    DxFormModule,
    DxDataGridModule,
    DxBoxModule,
    FormsModule,
    TranslateModule,
  ],

  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderModule {}
